import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function Register() {
  const { registerFirm } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ company_name: "", name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const upd = (k, v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setLoading(true);
    try {
      await registerFirm({ ...f, email: f.email.trim().toLowerCase() });
      toast.success("Workspace created!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-[#7A7571] hover:text-[#2C2A29] mb-8">
          <ArrowLeft size={16} /> Back
        </Link>
        <div className="card-soft !p-10">
          <div className="mb-8">
            <div className="w-12 h-12 rounded-2xl bg-[#E07A5F] flex items-center justify-center text-white font-display font-bold text-xl mb-6">R</div>
            <h1 className="font-display text-3xl font-semibold text-[#2C2A29]">Create your workspace</h1>
            <p className="text-[#7A7571] mt-2">One workspace per ID firm. Invite your team once you're in.</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <Field label="Firm / Company name" testId="register-company"
              value={f.company_name} onChange={(v) => upd("company_name", v)} placeholder="Studio Nordic Pte Ltd" />
            <Field label="Your name" testId="register-name"
              value={f.name} onChange={(v) => upd("name", v)} placeholder="Jane Tan" />
            <Field label="Work email" testId="register-email" type="email"
              value={f.email} onChange={(v) => upd("email", v)} placeholder="jane@studionordic.com" />
            <Field label="Password" testId="register-password" type="password"
              value={f.password} onChange={(v) => upd("password", v)} placeholder="At least 6 characters" />
            <button data-testid="register-submit" disabled={loading} className="btn-primary w-full mt-2">
              {loading ? "Creating…" : "Create workspace"}
            </button>
          </form>
          <div className="mt-6 text-center text-sm text-[#7A7571]">
            Already have one? <Link to="/login" className="text-[#E07A5F] font-semibold">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, testId, value, onChange, type = "text", placeholder }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-widest font-bold text-[#7A7571] mb-2 block">{label}</label>
      <input data-testid={testId} type={type} required value={value}
        onChange={(e) => onChange(e.target.value)} className="input-soft" placeholder={placeholder} />
    </div>
  );
}
